<template>
  <drawer :opened.sync="opened" @close="onCloseBtnClick">
    <template #header>{{operatorTip}}{{editName}}</template>

    <template #body>
      <el-form ref="form" :model="model" @keydown.native.enter.prevent="onSaveContinueBtnClick">
        <el-row :gutter="gutter">
          <el-col :span="8">
            <el-form-item
              label="分组名称"
              prop="name"
              :rules="[{
                required: true,
                message: '请输入分组名称'
              }]"
            >
              <el-input v-model="model.name" placeholder="请输入分组名称" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="gutter">
          <el-col :span="8">
            <el-form-item
              label="图标"
              prop="iconId"
              :rules="[{
                required: true,
                message: '请选择图标'
              }]"
              class="form-wapper"
            >
            <el-popover
              placement="bottom"
              width="300"
              trigger="click"
              v-model="visible"
            >

              <div class="icon-wapper">
                <el-radio-group v-model="model.iconId" @change="visible = false">
                  <el-radio v-for="item in iconOptions" :key="item.id" :label="item.id">
                    <span style="font-size: 20px;" :class="item.icon"></span>
                  </el-radio>
                </el-radio-group>
              </div>

              <el-input :value="`${iconMap[model.iconId] ? iconMap[model.iconId].name : ''}`" readonly placeholder="请选择图标" slot="reference">
                <template slot="prepend">
                  <span :class="`${iconMap[model.iconId] ? iconMap[model.iconId].icon : ''}`" style="font-size: 20px;"></span>
                </template>
              </el-input>
            </el-popover>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
      <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
    </template>
  </drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'Editor',
  extends: BaseEditor,
  props: {
    iconOptions: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    iconMap () {
      return this.iconOptions.reduce((map, el) => {
        map[el.id] = el
        return map
      }, {})
    }
  },
  methods: {
    initModel () {
      return {
        id: null,
        name: '',
        iconId: ''
      }
    },
    close () {
      this.clearFormValid()
      this.opened = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-wapper {
  /deep/ .el-form-item__content .icon-class {
    width: 100%;
    height: 40px;
    border: 1px solid #DCDFE6;

    .el-input {
      .el-input__inner {
        display: none;
      }
      .el-input__suffix {
        width: 40px;
        height: 40px;
      }

      .el-input__prefix {
        width: 40px;
        height: 40px;

        > div > span {
          line-height: 40px;
          color: black;
        }
      }
    }
  }
}
.icon-wapper {
  max-height: 150px;
  overflow: auto;
  /deep/ .el-radio-group{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;

    > label {
      width: 25px;
      height: 25px;
      line-height: 25px;
      margin-right: 10px;
      > .el-radio__input {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/08EnvGroup/Editor.vue